import numeral from 'numeral';

export default (n) => (
  numeral(n).format('0.0')
)



// WEBPACK FOOTER //
// ./src/formatters/number.js